// AuthModal.js — Connexion / Inscription

import React, { useState } from 'react';
import { signIn, signUp } from '../lib/supabase';

export function AuthModal({ onClose, onSuccess }) {
  const [mode, setMode]         = useState('login');
  const [email, setEmail]       = useState('');
  const [password, setPassword] = useState('');
  const [error, setError]       = useState('');
  const [loading, setLoading]   = useState(false);
  const [confirm, setConfirm]   = useState(false);

  const handleSubmit = async () => {
    setError('');
    if (!email || !password) return setError('Email et mot de passe requis');
    setLoading(true);
    try {
      if (mode === 'login') {
        const { data, error } = await signIn(email, password);
        if (error) throw error;
        onSuccess(data.user);
        onClose();
      } else {
        const { error } = await signUp(email, password);
        if (error) throw error;
        setConfirm(true);
      }
    } catch (e) {
      setError(e.message || 'Erreur de connexion');
    }
    setLoading(false);
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-box" onClick={e => e.stopPropagation()}>
        <button className="close-btn modal-close" onClick={onClose}>×</button>

        {confirm ? (
          <div className="modal-confirm">
            <span className="confirm-icon">✉️</span>
            <h3>Vérifiez vos emails</h3>
            <p>Un lien de confirmation a été envoyé à <strong>{email}</strong>.<br/>Cliquez dessus puis revenez vous connecter.</p>
            <button className="modal-btn" onClick={() => { setConfirm(false); setMode('login'); }}>
              Se connecter
            </button>
          </div>
        ) : (
          <>
            <div className="modal-tabs">
              <button className={`modal-tab ${mode === 'login' ? 'active' : ''}`} onClick={() => { setMode('login'); setError(''); }}>Connexion</button>
              <button className={`modal-tab ${mode === 'register' ? 'active' : ''}`} onClick={() => { setMode('register'); setError(''); }}>Inscription</button>
            </div>

            <h2 className="modal-title">{mode === 'login' ? 'Bon retour !' : 'Créer un compte'}</h2>
            <p className="modal-sub">{mode === 'login' ? 'Connectez-vous pour contribuer à l\'histoire' : 'Rejoignez Chronos et soumettez des événements'}</p>

            <div className="modal-fields">
              <div className="modal-field">
                <label>Email</label>
                <input type="email" value={email} onChange={e => setEmail(e.target.value)}
                  placeholder="vous@example.com" onKeyDown={e => e.key === 'Enter' && handleSubmit()} autoFocus />
              </div>
              <div className="modal-field">
                <label>Mot de passe {mode === 'register' && <span className="field-hint">(min. 6 caractères)</span>}</label>
                <input type="password" value={password} onChange={e => setPassword(e.target.value)}
                  placeholder="••••••••" onKeyDown={e => e.key === 'Enter' && handleSubmit()} />
              </div>
            </div>

            {error && <div className="modal-error">⚠️ {error}</div>}

            <button className="modal-btn" onClick={handleSubmit} disabled={loading}>
              {loading ? 'Chargement…' : mode === 'login' ? 'Se connecter' : 'Créer mon compte'}
            </button>
          </>
        )}
      </div>
    </div>
  );
}
